import React from "react";
import checkImg from "../../../../../assets/images/bookPage/check.svg";

export const FeaturesList = () => {
  const items = [
    '2,000+ Happy Customers',
    '100+ 5-Star Reviews',
    'Easy Rescheduling, No Fees'
  ]

  return <div className="features-list">
    {items.map((item, i) => (
      <div className="features-list-item" key={`header-item-${i}`}>
        <img src={checkImg}/>
        {item}
      </div>))}
  </div>
}